import type { HorrorRaceState } from "../types/game-state";
import { shufflePool } from "../utils/coin-pool";
import { createSeededRandom } from "../utils/seeded-random";

/**
 * Apply a `shuffle_pool` event deterministically from its seed. Used by BOTH
 * the client store and the server-side validator so they shuffle identically
 * and therefore draw the same coins (see seeded-random.ts).
 */
export function applyShufflePool(
  state: HorrorRaceState,
  seed: number,
): HorrorRaceState {
  return {
    ...state,
    coinPool: shufflePool(state.coinPool, createSeededRandom(seed)),
  };
}
